module.exports = __webpack_public_path__ + "static/assets/f5900afe4d83926044931d43a7b7a64b.png";